import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Div, Icon, Input, Text } from '@pinpoint/design-kit';
import CONSTANTS from 'src/store/constants';

function GraphicCard({
  title: defaultTitle,
  cardProps,
  titleProps,
  titleTextProps,
  titleSuffix,
  editTitle,
  onEdit,
  children,
}) {
  const [isEditMode, setEditMode] = useState(false);
  const [text, setText] = useState(defaultTitle);
  const [title, setTitle] = useState(defaultTitle);

  return (
    <Div w="100%" h="100%" bg="white" p={{ x: '1.5em', y: '0.25rem' }} rounded="md" {...cardProps}>
      <Div d="flex" align="center" justify="space-between" style={{ position: 'relative' }} {...titleProps}>
        <Div d="flex" align="center" style={{ position: 'absolute' }} top="1.5rem" zIndex="99">
          {editTitle === true ||
          editTitle === CONSTANTS.CONTROL_STATES.ENABLED ||
          editTitle === CONSTANTS.CONTROL_STATES.DISABLED ? (
            isEditMode ? (
              <>
                <Input
                  w="10rem"
                  h="2.4rem"
                  value={text}
                  onChange={(e) => {
                    setText(e.target.value);
                  }}
                />
                <Div d="flex" flexDir="column">
                  <Button
                    h="16px"
                    w="16px"
                    p="0"
                    margin="1px"
                    bg="secondary"
                    hoverBg="white"
                    rounded="sm"
                    color="tabSelected"
                    disabled={editTitle === CONSTANTS.CONTROL_STATES.DISABLED}
                    onClick={() => {
                      setEditMode(false);
                    }}
                  >
                    <Icon name="Cross" color="tabSelected" size="16px" />
                  </Button>
                  <Button
                    h="16px"
                    w="16px"
                    p="0"
                    margin="1px"
                    bg="secondary"
                    hoverBg="white"
                    rounded="sm"
                    color="tabSelected"
                    disabled={editTitle === CONSTANTS.CONTROL_STATES.DISABLED}
                    onClick={() => {
                      onEdit(text);
                      setTitle(text);
                      setEditMode(false);
                    }}
                  >
                    <Icon name="Checked" color="tabSelected" transform="scale(0.75)" />
                  </Button>
                </Div>
              </>
            ) : (
              <>
                <Button
                  h="18px"
                  w="18px"
                  p="1px"
                  m="0 .5em 0 0"
                  bg="secondary"
                  hoverBg="white"
                  disabled={editTitle === CONSTANTS.CONTROL_STATES.DISABLED}
                  data-tip="Rename cluster"
                  onClick={() => {
                    setEditMode(true);
                  }}
                >
                  <Icon name="Edit" color="tabSeleted" transform="scale(0.75)" />
                </Button>
                <Text textSize="subtitle" {...titleTextProps}>
                  {title}
                </Text>
              </>
            )
          ) : null}
        </Div>
        <Div>{titleSuffix}</Div>
      </Div>

      <Div h="calc(100% - 1rem)">{children}</Div>
    </Div>
  );
}

GraphicCard.propTypes = {
  title: PropTypes.string.isRequired,
  cardProps: PropTypes.shape({}),
  titleProps: PropTypes.shape({}),
  titleTextProps: PropTypes.shape({}),
  editTitle: PropTypes.bool,
  onEdit: PropTypes.func,
  titleSuffix: PropTypes.node,
};

GraphicCard.defaultProps = {
  cardProps: {},
  titleProps: {},
  titleTextProps: {},
  editTitle: true,
  onEdit: () => null,
  titleSuffix: null,
};

export default GraphicCard;
